<template>
  <div class="not-found-container">
    <div class="content">
      <h1 class="title">404</h1>
      <p class="description">页面未找到</p>
      <router-link 
        to="/" 
        class="home-link"
      >
        返回首页
      </router-link>
    </div>
  </div>
</template>

<script setup>
// 404页面组件
</script>

<style lang="scss" scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f9fafb; // 类似 bg-gray-50 的颜色
}

.content {
  text-align: center;
}

.title {
  font-size: 6rem;
  font-weight: 700;
  color: #9ca3af; // 类似 text-gray-400 的颜色
  margin-bottom: 1rem;
}

.description {
  font-size: 1.25rem;
  color: #4b5563; // 类似 text-gray-600 的颜色
  margin-bottom: 2rem;
}

.home-link {
  background-color: var(--el-color-primary); // 使用 Element Plus 主题色
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s ease;
  text-decoration: none; // 去掉下划线

  &:hover {
    background-color: var(--el-color-primary-dark-2); // 使用 Element Plus 深色主题
    text-decoration: none; // 确保悬停时也没有下划线
  }
}
</style>